import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LinkContainer from '../components/LinkContainer';
import useOutsideClick from '../hooks/useOutsideClick';
import { logoutUser } from '../actions/app';


const LARGE_SCREEN_WIDTH = 1600;

const NavigationBar = ({
  name,
  avatar = null,
  hasUnviewedResponse,
  logoutUser,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openMenu = () => {
    if (window.innerWidth < LARGE_SCREEN_WIDTH) {
      setIsOpen(true);
    }
  };

  const closeMenu = () => {
    if (window.innerWidth < LARGE_SCREEN_WIDTH) {
      setIsOpen(false);
    }
  };

  const toggleMenu = () => {
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // Closes the navigation bar when clicking outside of it.
  const navRef = useOutsideClick(() => {
    if (isOpen) {
      closeMenu();
    }
  });

  const logout = () => {
    logoutUser();
  };

  const showTitle = !isOpen && window.innerWidth < LARGE_SCREEN_WIDTH;

  return (
    <nav ref={navRef} className={isOpen ? 'navigation active' : 'navigation'}>
      <div className={isOpen ? 'menu-wrap active' : 'menu-wrap'}>
        <div className="menu-logo-helper-hidden" />
        <div className="menu-overflow">
          <LinkContainer to="/" onClick={closeMenu}>
            <div className="menu-logo" />
          </LinkContainer>
          <ul className="menu">
            <li className="menu-item">
              <NavLink
                className="menu-link"
                to="/all-vacancies"
                title={showTitle ? 'Вакансии' : undefined}
                onClick={closeMenu}
              >
                <span className="icon-wrap">
                  <FontAwesomeIcon
                    className="item-icon"
                    icon="bullhorn"
                  />
                </span>
                <span className="menu-link-text">Вакансии</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                className="menu-link"
                to="/responses"
                title={showTitle ? 'Отклики' : undefined}
                onClick={closeMenu}
              >
                {hasUnviewedResponse && <span className="menu-link-red-dot" />}
                <span className="icon-wrap">
                  <FontAwesomeIcon
                    className="item-icon"
                    icon="check-circle"
                  />
                </span>
                <span className="menu-link-text">Отклики</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                className="menu-link"
                to="/profile"
                title={showTitle ? 'Профиль' : undefined}
                onClick={closeMenu}
              >
                <span className="icon-wrap">
                  <FontAwesomeIcon
                    className="item-icon"
                    icon="user"
                  />
                </span>
                <span className="menu-link-text">Профиль</span>
              </NavLink>
            </li>

            <li className="menu-item">
              <NavLink
                className="menu-link"
                to="/resume"
                title={showTitle ? 'Профиль' : undefined}
                onClick={closeMenu}
              >
                <span className="icon-wrap">
                  <FontAwesomeIcon
                    className="item-icon"
                    icon="file"
                  />
                </span>
                <span className="menu-link-text">Резюме</span>
              </NavLink>
            </li>

            <li className="menu-logout-wrap">
              <span className="icon-wrap" onClick={logout}>
                <FontAwesomeIcon
                  className="item-icon"
                  icon="sign-out-alt"
                />
              </span>
              <span className="menu-logout" onClick={logout}>Выход</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="navigation-panel-top">
        <div className={isOpen ? 'navigation-panel-top-moved active' : 'navigation-panel-top-moved'}>
          <div
            className={isOpen ? 'hamburger hamburger--arrow is-active' : 'hamburger hamburger--arrow'}
            onClick={toggleMenu}
          >
            <div className="hamburger-box">
              <div className="hamburger-inner" />
            </div>
          </div>
        </div>
        <div className="navigation-panel-top-profile">
          <div className="navigation-panel-top-person">
            <LinkContainer to="/profile" onClick={closeMenu}>
              <div className="navigation-panel-top-person-avatar">
                {avatar && <img src={avatar} alt="avatar" />}
              </div>
            </LinkContainer>
            <LinkContainer to="/profile" onClick={closeMenu}>
              <span className="navigation-panel-top-person-name">
                {name}
              </span>
            </LinkContainer>
          </div>
          <div className="navigation-panel-top-logout">
            <span className="navigation-panel-top-logout-text" onClick={logout}>Выход</span>
            <span className="icon-wrap" onClick={logout}>
              <FontAwesomeIcon
                className="item-icon"
                icon="sign-out-alt"
              />
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
};

NavigationBar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  hasUnviewedResponse: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const {
    entities: { user },
    responses: { has_not_viewed = false },
  } = state;
  const { first_name: name, avatar } = user;
  return ({
    name,
    avatar,
    hasUnviewedResponse: has_not_viewed,
  });
};

const mapDispatchToProps = dispatch => ({
  logoutUser: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
